export const environment = {
  production: true,
  publicConfigUrl: '/api/public/configuration',
  localDevSsoRedirect: false,
  ssoLoginRedirectIntervalInHours: 24,

  sentryDisabledOnUrls: new RegExp('^(?!.*(?:rpqa20-gi.rampitplatform.com|rpqa20-postman.rampitplatform.com|localhost)).*$'),
  // sentry config
  sentry: {
    DSN: 'https://6ee80c4b2e33469825ae65d745feb686@o4504165036457984.ingest.us.sentry.io/4509331326435328',
    // environment setting needs to be updated as per the environment this is deployed to
    environment: 'prod',
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  sentryIgnoredErrors: ['auth/wrong-password', 'auth/invalid-email', 'auth/user-not-found'],
};
